import { Box, Typography } from "@mui/material";
import Button from "../Common/Button";
import Input from "../Common/Input";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { addOrganization } from "../../store/organization/organization.action";

const CreateOrganization = () => {
  const dispatch = useDispatch();
  const [organizationName, setOrganizationName] = useState("");
  const [organizationWebsite, setOrganizationWebsite] = useState("");
  const [organizationEmail, setOrganizationEmail] = useState("");
  const [organizationPhone, setOrganizationPhone] = useState("");
  const [organizationLogo, setOrganizationLogo] = useState("");
  const [organizationAddress, setOrganizationAddress] = useState("");

  const handleLogoUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      setOrganizationLogo(reader.result);
    };
  };

  const resetForm = () => {
    // Reset form
    setOrganizationName("");
    setOrganizationWebsite("");
    setOrganizationEmail("");
    setOrganizationPhone("");
    setOrganizationLogo("");
    setOrganizationAddress("");
  };

  const handleSubmit = async () => {
    const payload = {
      name: organizationName,
      website: organizationWebsite,
      email: organizationEmail,
      phone: organizationPhone,
      logo: organizationLogo,
      address: organizationAddress,
    };

    const res = dispatch(addOrganization(payload));

    if (res) {
      resetForm();
    }
  };

  return (
    <Box className="organizationRegister">
      <Typography variant="h6" component="h6">
        Add Organization
      </Typography>
      <hr className="border-bottom" />
      <form>
        <div className="row gy-4">
          <div className="col-12 d-flex justify-content-end align-items-center">
            <Button
              type="button"
              className={"submit"}
              onClick={handleSubmit}
            >
              Register
            </Button>
          </div>
          <div className="col-12 col-lg-6">
            <Input
              label="Name"
              type="text"
              placeholder="Enter Name"
              value={organizationName}
              onChange={(e) => setOrganizationName(e.target.value)}
            />
          </div>
          {/* <div className="col-12 col-lg-6">
            <Input
              label="Website"
              type="url"
              placeholder="Enter Website"
              value={organizationWebsite}
              onChange={(e) => setOrganizationWebsite(e.target.value)}
            />
          </div> */}
          <div className="col-12 col-lg-6">
            <Input
              label="Email"
              type="email"
              placeholder="Enter Email"
              value={organizationEmail}
              onChange={(e) => setOrganizationEmail(e.target.value)}
            />
          </div>
          {/* <div className="col-12 col-lg-6">
            <Input
              label="Phone"
              type="number"
              placeholder="Enter Phone"
              value={organizationPhone}
              onChange={(e) => setOrganizationPhone(e.target.value)}
            />
          </div> */}
          {/* <div className="col-12 col-lg-6">
            <Input
              label="Logo"
              type="file"
              accept={"image/*"}
              onChange={(e) => handleLogoUpload(e)}
            />
            {organizationLogo && (
              <div className="mt-2 px-3 text-center">
                <img src={organizationLogo} height={100} />
              </div>
            )}
          </div> */}
          {/* <div className="col-12">
            <Input
              label="Address"
              type="text"
              placeholder="Enter Address"
              value={organizationAddress}
              onChange={(e) => setOrganizationAddress(e.target.value)}
            />
          </div> */}
        </div>
      </form>
    </Box>
  );
};

export default CreateOrganization;
